import axios from 'axios';

export const TOKEN_KEY = 'hc.access_token';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${baseURL || ''}/api`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  if (axios.isAxiosError(err)) {
    const detail = err.response?.data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
      return detail
        .map((d) => (d && typeof d === 'object' && 'msg' in d ? String(d.msg) : JSON.stringify(d)))
        .filter(Boolean)
        .join(' ');
    }
    if (detail && typeof detail === 'object' && 'msg' in detail) {
      return String(detail.msg);
    }
    if (err.message) return err.message;
  }
  return 'Something went wrong. Please try again.';
}
